


export enum RoomType {
    GROUP, OTO
}
